// ========== 全局配置 ==========
export const SAVE_KEY = 'dnf_save_v5';
export const VERSION = 'v5.0';
export const API_BASE = '/api';
export const AUTH_KEY = 'dnf_auth';
export const CHAR_KEY = 'dnf_char_id';

// CSS 变量的颜色被 style.css 的 :root 定义，JS 中可以直接用 var(--xxx) 在 style 属性中
